import { render, staticRenderFns } from "./VamosPaLaCalleActividadEvento.vue?vue&type=template&id=6bf207d4&scoped=true"
import script from "./VamosPaLaCalleActividadEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./VamosPaLaCalleActividadEvento.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf207d4",
  null
  
)

export default component.exports